export default __webpack_public_path__ + "static/kv-c6ac0c2f2834b8bcf0f91808d07bbbcc.mp4";